import { render, staticRenderFns } from "./DepositPrintout.vue?vue&type=template&id=5827c3d8&"
import script from "./DepositPrintout.vue?vue&type=script&lang=js&"
export * from "./DepositPrintout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports